import FormField from './FormField';
import React from 'react';
import PhoneInput, {
  getCountries,
  getCountryCallingCode,
} from 'react-phone-number-input/input';
import en from 'react-phone-number-input/locale/en.json';

const FieldPhoneInput = function (props: {
  country: string;
  name: string;
  value: string;
  onChange: (phone: string) => void;
  onChangeCountry: (country: string) => void;
}) {
  return (
    <FormField hasAddon={true} className="eb-phone-input">
      <div className="control">
        <span className="select">
          <span className="eb-phone-input__flag">
            <span
              className={`flag-icon flag-icon flag-icon-squared flag-icon-${props.country.toLowerCase()}`}
            />
            <span className="eb-phone-input__label">
              +{getCountryCallingCode(props.country)}
            </span>
          </span>

          <select
            value={props.country}
            onChange={e => props.onChangeCountry(e.target.value)}
          >
            {getCountries().map(country => (
              <option key={country} value={country}>
                {en[country]} +{getCountryCallingCode(country)}
              </option>
            ))}
          </select>
        </span>
      </div>
      <div className="control is-expanded">
        <PhoneInput
          className="input"
          name={props.name}
          country={props.country}
          value={props.value}
          onChange={props.onChange}
        />
      </div>
    </FormField>
  );
};

export default FieldPhoneInput;
